<template>
  <div>
    <collapsible-section
        class="collapse-item"
        :id="`dynamicInputsCollapse-${dynamicInputObject.id}-${dropdownControlId}`"
        control-name="dynamicInputCollapse"
        :is-open="false"
    >
      <template #section-header>
        {{ dynamicInputObject.name }}
      </template>

      <template #section-contents>
        <field-item
            @click="select(dynamicInputsSection.select(dynamicInputObject, path))"
            :disabled="handler.isDisabled(dynamicInputObject, parentTreeContext)"
        >
          <row>
            <prefix>
              <icon glyph="box"/>
            </prefix>
            <column>
              {{ dynamicInputObject.name }}
            </column>
          </row>
        </field-item>

        <collapsible-section
            class="collapse-item"
            :id="`dynamicInputPropertiesCollapse-${dynamicInputObject.id}-${dropdownControlId}-properties`"
            control-name="dynamicInputPropertiesCollapse"
            :is-open="false"
        >
          <template #section-header>
            Properties
          </template>

          <template #section-contents>
            <dynamic-input-section-data
                :handler="handler"
                :q="q"
                :section="dynamicInputsSection"
                :parent-tree-context="computedChildTreeContext"
                :path="path"
                @select="select"
            ></dynamic-input-section-data>
          </template>
        </collapsible-section>
      </template>
    </collapsible-section>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import handlerComponentsMixin from "~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin";
import handlerTreeContextMixin from "~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin";
import DynamicInputSectionData from "~/components/dynamicFieldsTrees/handlerComponents/dynamic-input-section-data.vue";
import ProcessFlowCertificateDynamicInputsHandler from "~/models/dynamicFields/handlers/processFlows/processFlowCertificateDynamicInputsHandler";
import ProcessFlowDynamicInputFieldsHandler from "~/models/dynamicFields/handlers/processFlows/processFlowDynamicInputFieldsHandler";
import DynamicInput from "~/models/dynamicInput";
import CertificateDynamicInput from "../../../../formability/certificateBuilder/models/certificateDynamicInput";
import {ReferencePathNode} from "~/models/referencePaths/referencePathNode";
import {IDynamicInputsConfig, IDynamicTreeContext} from "~/interfaces/dynamicFieldsInterfaces";

export default Vue.extend({
  mixins: [handlerComponentsMixin, handlerTreeContextMixin],
  components: {
    DynamicInputSectionData,
  },
  props: {
    handler: {
      type: Object as () => ProcessFlowCertificateDynamicInputsHandler | ProcessFlowDynamicInputFieldsHandler,
      required: true,
    },
    dynamicInputObject: {
      type: Object as () => DynamicInput | CertificateDynamicInput,
    },
    path: {
      type: Array as () => ReferencePathNode[],
      default: () => {
        return [];
      },
    },
  },
  computed: {
    dynamicInputsSection(): Pick<IDynamicInputsConfig, 'properties' | 'objects' | 'select'> {
      return this.handler.dynamicInputsSection(this.lowerQ, this.dynamicInputObject);
    },
    treeContext(): Partial<IDynamicTreeContext> {
      return {
        parent: this.dynamicInputObject,
        isTopLevelCollectionAssigned: this.parentTreeContext.isTopLevelCollectionAssigned || this.handler.isTopLevelCollection(this.dynamicInputObject, this.parentTreeContext),
        referencePathNodesToLevel: this.path,
      };
    },
  },
});
</script>